import { render, staticRenderFns } from "./WizardProduct.vue?vue&type=template&id=68162d45&"
import script from "./WizardProduct.vue?vue&type=script&lang=js&"
export * from "./WizardProduct.vue?vue&type=script&lang=js&"
import style0 from "./WizardProduct.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports